import React from 'react';
import { useTrans } from '../../hooks/useTrans';
import AuthPanel from '../../components/layout/auth/AuthPanel';

export default function LinkExpired() {
    const translate = useTrans();

    return (
        <AuthPanel>
            <h5 className="text-lg font-bold text-[#003545]">
                {translate('Link verlopen of ongeldig')}
            </h5>
            <p className="text-sm text-[#003545] mt-4">
                {translate('Kan de pagina niet ophalen, omdat de link is verlopen of ongeldig is.')}
                <br />
                {translate('Neem contact op met de gebruikersbeheerder van uw organisatie.')}
            </p>
        </AuthPanel>
    );
}
